import {Svg, Row, Section} from "./styledBackgroundSimple";
import { ReactComponent as Clubs } from '../../assets/images/backgrounds/icons/clubs.svg';
import { ReactComponent as Hearts } from '../../assets/images/backgrounds/icons/hearts.svg';
import { ReactComponent as Spades } from '../../assets/images/backgrounds/icons/spades.svg';
import { ReactComponent as Diamonds } from '../../assets/images/backgrounds/icons/diamonds.svg';
import { ReactComponent as Dice1 } from '../../assets/images/backgrounds/icons/dice1.svg';
import { ReactComponent as Dice2 } from '../../assets/images/backgrounds/icons/dice2.svg';
import { ReactComponent as Dice3 } from '../../assets/images/backgrounds/icons/dice3.svg';
import { ReactComponent as Dice4 } from '../../assets/images/backgrounds/icons/dice4.svg';
import { ReactComponent as Dice5 } from '../../assets/images/backgrounds/icons/dice5.svg';
import { ReactComponent as Dice6 } from '../../assets/images/backgrounds/icons/dice6.svg';
import { ReactComponent as Casino777 } from '../../assets/images/backgrounds/icons/casino777.svg';
import { ReactComponent as SpadeToken } from '../../assets/images/backgrounds/icons/spadeToken.svg';
import {useEffect, useState} from "react";

function Icon({ Component, glow, color }) {
    return (
        <Svg
            as={Component}
            className={`icon ${glow ? 'glow' : ''}`}
            glowColor={color}
        />
    );
}

const icons = [Dice1, Clubs, Dice2, Hearts, Dice3, Spades, Dice4, Diamonds, Dice5, Casino777, Dice6, SpadeToken];
function IconRow({ rowIndex, activeIndex, activeColor, iconsPerRow }) {

    const STEP = 12;
    const rowWidth = iconsPerRow * 2;
    const rowStart = rowIndex * rowWidth;
    const offset = activeIndex % 12;

    return (
        <Row>
            <div>
                {Array.from({ length: iconsPerRow }).map((_, i) => {
                    const glow =
                        activeIndex >= rowStart &&
                        activeIndex < rowStart + rowWidth &&
                        i % STEP === offset;
                    return (
                        <Icon
                            key={i}
                            Component={icons[i % icons.length]}
                            glow={glow}
                            color={activeColor}
                        />
                    );
                })}
            </div>

            <div>
                {Array.from({ length: iconsPerRow }).map((_, i) => {
                    const glow =
                        activeIndex >= rowStart &&
                        activeIndex < rowStart + rowWidth &&
                        i % STEP === offset;
                    return (
                        <Icon
                            key={`clone-${i}`}
                            Component={icons[i % icons.length]}
                            glow={glow}
                            color={activeColor}
                        />
                    );
                })}
            </div>
        </Row>
    );
}

const NEON_COLORS = [
    '#132bff',
    '#e41f29',
    '#e22ab1',
    '#ff9800',
    '#137647'
];
export default function BackgroundSimple() {
    const ROWS = 20;
    const ICONS_PER_ROW = 24;
    const TOTAL_ICONS = ROWS * ICONS_PER_ROW * 2;

    const VISIBLE_ROW_START = 6;
    const VISIBLE_ROW_END = 12;

    const [activeIndex, setActiveIndex] = useState(0);
    const [activeColor, setActiveColor] = useState(NEON_COLORS[0]);

    useEffect(() => {
        const interval = setInterval(() => {

            const rowIndex =
                VISIBLE_ROW_START +
                Math.floor(
                    Math.random() * (VISIBLE_ROW_END - VISIBLE_ROW_START + 1)
                );

            const rowWidth = ICONS_PER_ROW * 2;
            const iconIndex = Math.floor(Math.random() * rowWidth);

            const nextIndex = rowIndex * rowWidth + iconIndex;
            setActiveIndex(nextIndex);

            setActiveColor(NEON_COLORS[Math.floor(Math.random() * NEON_COLORS.length)]);

        }, 2000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Section>
            {Array.from({ length: ROWS }).map((_, rowIndex) => (
                <IconRow
                    key={rowIndex}
                    rowIndex={rowIndex}
                    activeIndex={activeIndex}
                    activeColor={activeColor}
                    iconsPerRow={ICONS_PER_ROW}
                />
            ))}
        </Section>
    );
}
